enum OverlayTarget {
	SCREEN = 'SCREEN',
	POLICY_NOTES = 'POLICY NOTES',
	POLICY_NOTE_EMAILS = 'POLICY NOTE_EMAILS',
	ELIGIBILITIES = 'ELIGIBILITIES',
	NONE = 'NONE',
}

export default OverlayTarget;